import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import {m2mTokenColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import {useEffect} from "react";

const M2MTokens = () => {
  const {data, loading, list} = useApiRequest("/m2m-tokens");

  useEffect(() => {
    list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Window title={"M2M Tokens"}>
      {loading ? (
        <div style={{textAlign: "center", padding: "20px"}}>
          <span style={{fontSize: "18px", color: "#666"}}>Cargando...</span>
        </div>
      ) : (
        <ListView columns={m2mTokenColumns} data={data?.data} getRowId={(row) => row.id} />
      )}
    </Window>
  );
};

export default M2MTokens;
